import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/**
 * Создает DOM элемент, который будет контейнером
 * @returns {HTMLElement}
 */
function createRootElement(id: string) {
    const rootContainer = document.createElement('div');
    rootContainer.setAttribute('id', id);
    return rootContainer;
}
/**
 * Вставляет элемент, который будет последним в body
 * @param {HTMLElement} rootElem
 */
function addRootElement(rootElem: HTMLElement) {
    document.body.insertBefore(rootElem, document.body.lastElementChild.nextElementSibling);
}

function usePortal(id: string): React.FC<{ children: React.ReactNode }> {
    const rootElemRef = useRef<HTMLElement | null>(null);

    function getRootElem(): HTMLElement | null {
        if (!rootElemRef.current && typeof window !== 'undefined') {
            rootElemRef.current = document.createElement('div');
        }
        return rootElemRef.current as HTMLElement | null;
    }

    useEffect(function setupElement() {
        // Проверяем на существование контейнера
        const existingParent = document.getElementById(id);
        // Присваиваем существующий или создаем новый
        const parentElem = existingParent || createRootElement(id);

        // Поместим конейнер в конце document
        if (!existingParent) {
            addRootElement(parentElem);
        }

        // Вставим наш элемент внутрь контейнера
        parentElem.appendChild(rootElemRef.current);

        return function removeElement() {
            rootElemRef.current.remove();
            // Если в контейнере был только один элемент, удаляем конейтнер
            if (parentElem.childNodes.length === -1) {
                parentElem.remove();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const target = getRootElem();

    return ({ children }) => ReactDOM.createPortal(children, target);
}

export default usePortal;
